"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputDialog = void 0;
var React = require("react");
var Button_1 = require("../Button");
var InputDialog_st_css_1 = require("./InputDialog.st.css");
var TPAComponentsConfig_1 = require("../TPAComponentsConfig");
var Dialog_1 = require("../Dialog");
var types_1 = require("./types");
/** A dialog component that consists of a header and footer with action buttons, and might have overflowed content. */
var InputDialog = /** @class */ (function (_super) {
    __extends(InputDialog, _super);
    function InputDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputDialog.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, dataHook = _a["data-hook"], isOpen = _a.isOpen, onClose = _a.onClose, title = _a.title, subtitle = _a.subtitle, primaryButton = _a.primaryButton, secondaryButton = _a.secondaryButton, manualFocus = _a.manualFocus, fullscreen = _a.fullscreen, withoutDivider = _a.withoutDivider, ariaLabel = _a.ariaLabel, ariaLabelledBy = _a.ariaLabelledBy, ariaDescribedBy = _a.ariaDescribedBy, closeButtonAriaLabel = _a.closeButtonAriaLabel, closeButtonAriaLabelledby = _a.closeButtonAriaLabelledby, forceBWTheme = _a.forceBWTheme;
        return (React.createElement(TPAComponentsConfig_1.TPAComponentsConsumer, null, function (_a) {
            var mobile = _a.mobile;
            return (React.createElement(Dialog_1.Dialog, { isOpen: isOpen, onClose: onClose, className: InputDialog_st_css_1.st(InputDialog_st_css_1.classes.root, { mobile: mobile, fullscreen: fullscreen }, className, InputDialog_st_css_1.classes.dialog), contentClassName: InputDialog_st_css_1.classes.dialogContent, childrenWrapperClassName: InputDialog_st_css_1.classes.dialogChildrenWrapper, "data-hook": dataHook, manualFocus: manualFocus, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, closeButtonAriaLabel: closeButtonAriaLabel, closeButtonAriaLabelledby: closeButtonAriaLabelledby, forceBWTheme: forceBWTheme },
                React.createElement("div", { className: InputDialog_st_css_1.classes.header },
                    React.createElement("div", { className: InputDialog_st_css_1.classes.title }, title),
                    React.createElement("div", { className: InputDialog_st_css_1.classes.subtitle }, subtitle)),
                React.createElement("div", { className: InputDialog_st_css_1.classes.content }, children),
                !withoutDivider && React.createElement("div", { className: InputDialog_st_css_1.classes.divider }),
                React.createElement("div", { className: InputDialog_st_css_1.classes.footer },
                    primaryButton && (React.createElement(Button_1.Button, { upgrade: true, className: InputDialog_st_css_1.st(InputDialog_st_css_1.classes.button, {
                            primary: true,
                        }), onClick: primaryButton.onClick, "data-hook": types_1.InputDialogDataHooks.PrimaryButton }, primaryButton.text)),
                    secondaryButton && (React.createElement(Button_1.Button, { upgrade: true, priority: Button_1.PRIORITY.basicSecondary, className: InputDialog_st_css_1.st(InputDialog_st_css_1.classes.button, { secondary: true }), onClick: secondaryButton.onClick, "data-hook": types_1.InputDialogDataHooks.SecondaryButton }, secondaryButton.text)))));
        }));
    };
    InputDialog.displayName = 'InputDialog';
    InputDialog.defaultProps = {
        withoutDivider: false,
    };
    return InputDialog;
}(React.PureComponent));
exports.InputDialog = InputDialog;
//# sourceMappingURL=InputDialog.js.map